<template>
    <div class="hc" style=" border-radius: 15px; border: 1px solid #E3E3E3;">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
       <div class="text-center" style="font-size: .8em;">
           <div class="mt-1" v-if="hasEmpty" style="color: red;">
           Tienes padecimientos adicionales "sin definir"
           </div>
           <div class="mt-1" v-if="hasDuplicates" style="color: red;">
               Tienes padecimientos adicionales "duplicados"
           </div>
       </div>

       <div class="d-flex align-items-center row pl-3 pr-3">
           <div class="d-flex col-3 justify-content-start align-items-center mt-2 mb-1" style="border-right: 2px solid #E6E6E6;">
               <em class="diente_outline" style="width: 1.5em;"></em>
               <div style="font-weight: 500;">
                   <p class="mt-3 ml-3" v-if="diente.diente.diente.length<= 2"> OD {{ diente.diente.diente }}</p>
                   <p class="mt-3 ml-3" v-else>{{ diente.diente.diente }}</p>
               </div>
           </div>

           <div class="col-7">
               <div class="" style="min-height: 60px;">
                    <v-select id="padecimiento" name="padecimiento" placeholder="Agregar padecimiento"
                    v-model="diente.padecimiento"
                    :disabled="disable"
                    :options="padecimientos"
                    :class="statePadecimiento"
                    class="mt-3"
                    label="descripcion"
                    @input="cambioPadecimiento()" />
                    
                    <div v-if="!padecimientoExiste" class="text-left p-0" style="font-size: .7em;">Sin categoría seleccionada</div>
                    <div v-else class="text-left p-0" style="font-size: .7em;">{{ diente.padecimiento.idClasificacionClinica == 1 ? 'Prioridad clínica' : 'Hallazgos adicionales' }}</div>
               </div>
           </div>
           <div class="col-2">
               <input v-model="diente.seleccionar" style="" class="form-check-input mt-2"
                   type="checkbox" value="" id="flexCheckDefault">
               <b-button v-if="diente.visible" class="mostrar" size="sm" variant="link"
                   @click="cambiarVisibilidad()"
               >
                   <font-awesome-icon :icon="['fas', 'chevron-circle-up']"/>
               </b-button>
               <b-button v-if="!diente.visible && diente.padecimiento != null" class="esconder" size="sm" variant="link"
                   @click="cambiarVisibilidad()"
               >
                   <font-awesome-icon :icon="['fas', 'chevron-circle-down']"/>
               </b-button>
               <b-button v-if="!disable" size="sm" v-b-tooltip.hover.topright title="Eliminar Diente"
                   style="color: red !important;" variant="link"
                   @click="eliminarDiente()">
                   <font-awesome-icon icon="times-circle"/>
               </b-button>
           </div>
       </div>

       <b-collapse class="mt-4 pl-3 pr-3" :visible="diente.visible" :id="'collapse-'+index" style="min-height: 300px;">
           <div class="d-flex justify-content-between" v-if="diente.padecimiento !== null" style="width: 100%">
               <div style="width: 280px;">
                   <p class="text-left" style="margin-bottom: 0px; font-size: .9em;">Categoria:</p>
                   <v-select placeholder="Selecciona la categoría"
                       v-model="diente.padecimiento.idClasificacionClinica"
                       :options="diente.padecimiento.limitarClasificacion ? clasificacionClinicasLimitada : clasificacionClinicas"
                       label="clasificacionClinica"
                       :reduce="(variable) => variable.idClasificacionClinica"
                   />
               </div>
               <div class="d-flex justify-content-center align-items-center" style="width: 400px;">
                   <div class="d-flex justify-content-center align-items-center pl-3 pr-3" style="height: 2.5em;"
                       @click="opcionTabSeleccionada = index"
                       :class="opcionTabSeleccionada == index ? 'tabOpciones seleccionado' : 'tabOpciones'"
                       v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
                       <p class="mt-3" :class="opcionTabSeleccionada == index ? 'tabTxtSeleccionado' : 'tabTxt'">
                           {{ opt.nombre }} 
                       </p>
                   </div>
               </div>
           </div>

           <b-col cols="12" v-if="opcionTabSeleccionada === 1">
               <b-container class="mt-5" fluid>
                   <b-row  v-if="!disable && (padecimientosAdicionalesNoReq === undefined
                       || padecimientosAdicionalesNoReq === null
                       || padecimientosAdicionalesNoReq.length<5)">
                       <b-col cols="10" style="text-align: left">
                           <span>Agregar padecimientos adicionales al OD {{ diente.diente.diente }} </span>
                       </b-col>
                       <b-col cols="2" style="text-align: right">
                           <b-button size="md" v-b-tooltip.hover title="Agregar nuevo padecimiento"
                               variant="link" @click="agregarPadecimientoAdicional">
                               <font-awesome-icon icon="plus-circle"/>
                           </b-button>
                       </b-col>
                   </b-row>
       
                   <form ref="ads" @submit.prevent="submitf"
                       v-if="padecimientosAdicionalesNoReq !== undefined
                       && padecimientosAdicionalesNoReq !== null"
                   >
                       <b-row v-for="(padadd, idx) in padecimientosAdicionalesNoReq" v-bind:key="diente.diente + '-' + idx">
           
                           <b-col cols="8" style="padding-right: 0px;">
                               <v-select placeholder="Selecciona un padecimiento"
                                   v-model="padadd.pad"
                                   :disabled="disable"
                                   :options="padecimientos"
                                   :class="statePadecimientoAdicional"
                                   label="descripcion"
                                   :reduce="(variable) => variable.idPadecimiento"
                                   :style="padadd.pad==null? 'border: solid red 1px;': ''"
                                   @input="actualizarPadecimientosAdds"
                               />
                           </b-col>
                           <b-col style="padding-left: 0px;">
                               <b-button size="md" v-b-tooltip.hover title="Eliminar padecimiento"
                                   variant="link" style="color: red !important;"
                                   @click="quitarPadecimientoAdicional(idx)"
                                   v-if="!disable">
                                   <font-awesome-icon icon="times-circle"/>
                               </b-button>
                           </b-col>
                       </b-row>
                   </form>

                   <b-row>
                       <b-col cols="3"></b-col>
                       <b-col style="text-align: center">
                           <span v-if="padecimientosAdicionalesNoReq === undefined
                               || padecimientosAdicionalesNoReq === null
                               || padecimientosAdicionalesNoReq.length ===0">
                               Sin padecimientos adicionales
                           </span>
                       </b-col>
                       <b-col cols="3"></b-col>
                   </b-row>
               </b-container>
           </b-col>
         <b-col cols="12" class="mt-4 mb-4" v-if="opcionTabSeleccionada === 2">
           <b-container fluid>
             <div v-if="loading" class="d-flex justify-content-center align-items-center mt-5">
               <div class="your-div">
                 <b-spinner variant="primary" label="Spinning"></b-spinner>
               </div>
             </div>
             <div  v-if="!loading && sugerenicaUno.length === 0 && sugerenicaDos.length === 0 && sugerenicaTres.length === 0" class="d-flex justify-content-center align-items-center mt-4" style="min-height: 22vh;">
               <p>Actualmente, no contamos con sugerencias.</p>
             </div>
             <b-card-group deck class="text-center">
               <b-card  v-if="sugerenicaUno != null && sugerenicaUno !== undefined && sugerenicaUno.length > 0" bg-variant="light">
                 <div>
                   <p class="tituloSugerencia">Sugerencia 1</p>
                 </div>
                 <div v-for="(sugerenciaTx,i) in sugerenicaUno" :key="i">
                    <b-card-text v-if="sugerenciaTx.idKit === null" class="mb-2">{{ sugerenciaTx.nombreTratamiento}}</b-card-text>
                    <b-card-text v-else class="mb-2">
                        <span class="text-left"><b-badge pill variant="success">KIT</b-badge></span>
                        {{ sugerenciaTx.nombreTratamiento}}
                        <b-button v-b-toggle="sugerenciaTx.idKit+'t'+i+'ind'"
                            variant="outline-secondary" size="sm" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;">
                            <b-icon icon="chevron-down" font-scale="1.1"></b-icon>
                        </b-button>
                    </b-card-text>
                    <b-collapse :id="sugerenciaTx.idKit+'t'+i+'ind'" accordion="my-accordion1"
                        role="tabpanel">
                        <b-row class="ml-2 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in sugerenciaTx.listaTratamientos" :key="indexTratamiento">
                            <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                            <b-col align="left"><span>{{ trt.nombreTratamiento }}</span></b-col>
                        </b-row>
                    </b-collapse>
                 </div>
               </b-card>
               <b-card  v-if="sugerenicaDos != null && sugerenicaDos !== undefined && sugerenicaDos.length > 0" bg-variant="light">
                 <div>
                   <p class="tituloSugerencia">Sugerencia 2</p>
                 </div>
                 <div v-for="(sugerenciaTx,i) in sugerenicaDos" :key="i">
                    <b-card-text v-if="sugerenciaTx.idKit === null" class="mb-2">{{ sugerenciaTx.nombreTratamiento}}</b-card-text>
                    <b-card-text v-else class="mb-2">
                        <span class="text-left"><b-badge pill variant="success">KIT</b-badge></span>
                        {{ sugerenciaTx.nombreTratamiento}}
                        <b-button v-b-toggle="sugerenciaTx.idKit+'t'+i+'ind'"
                            variant="outline-secondary" size="sm" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;">
                            <b-icon icon="chevron-down" font-scale="1.1"></b-icon>
                        </b-button>
                    </b-card-text>
                    <b-collapse :id="sugerenciaTx.idKit+'t'+i+'ind'" accordion="my-accordion2"
                        role="tabpanel">
                        <b-row class="ml-2 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in sugerenciaTx.listaTratamientos" :key="indexTratamiento">
                            <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                            <b-col align="left"><span>{{ trt.nombreTratamiento }}</span></b-col>
                        </b-row>
                    </b-collapse>
                 </div>
               </b-card>
               <b-card  v-if="sugerenicaTres != null && sugerenicaTres !== undefined && sugerenicaTres.length > 0" bg-variant="light">
                 <div>
                   <p class="tituloSugerencia">Sugerencia 3</p>
                 </div>
                 <div v-for="(sugerenciaTx,i) in sugerenicaTres" :key="i">
                    <b-card-text v-if="sugerenciaTx.idKit === null" class="mb-2">{{ sugerenciaTx.nombreTratamiento}}</b-card-text>
                    <b-card-text v-else class="mb-2">
                        <span class="text-left"><b-badge pill variant="success">KIT</b-badge></span>
                        {{ sugerenciaTx.nombreTratamiento}}
                        <b-button v-b-toggle="sugerenciaTx.idKit+'t'+i+'ind'"
                            variant="outline-secondary" size="sm" class="mr-1 mt-1 marginbotones" style="max-width: 2vw; max-height: 2vw;">
                            <b-icon icon="chevron-down" font-scale="1.1"></b-icon>
                        </b-button>
                    </b-card-text>
                    <b-collapse :id="sugerenciaTx.idKit+'t'+i+'ind'" accordion="my-accordion3"
                        role="tabpanel">
                        <b-row class="ml-2 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in sugerenciaTx.listaTratamientos" :key="indexTratamiento">
                            <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                            <b-col align="left"><span>{{ trt.nombreTratamiento }}</span></b-col>
                        </b-row>
                    </b-collapse>
                 </div>
               </b-card>
             </b-card-group>
           </b-container>
         </b-col>
           <b-row v-if="diente.padecimiento != null && opcionTabSeleccionada === 0" class="mt-3">
               <b-col v-for="(lista,i) in diente.tratamientos" :key=" diente.diente.diente + 'tx'+i">
                   <HDTratamientos
                       :segundaOpcionCreada="segundaOpcionCreada"
                       :contraerCard="contraerCard"
                       :disable="disable"
                       :paquetes="paquetes"
                       :clasificacion="diente.padecimiento.clasificacion"
                       :tratamientos="lista"
                       :cat-tratamientos="catTratamientos"
                       :catalogokits="catalogokits"
                       :idPadecimiento="idPadecimiento"
                       :index="i"
                       :indexTarjeta="index"
                       @cambiarPaquete="cambiarPaquete"
                       @padecimientoModificado="padecimientoModificado">
                   </HDTratamientos>
               </b-col>
           </b-row>
       </b-collapse>
   </div>
 </template>
 
 <script>
 import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
 import HDTratamientos from "../diagnostico/HDTratamientos.vue"
 
 export default {
   name: "HDPadecimientos",
   components: {
       HDTratamientos,
   },
   props: {
       contraerCard: Boolean,
       catTratamientos: null,
       catalogokits: null,
       statePadecimiento: null,
       statePadecimientoAdicional: null,
       stateValidate: null,
       disable: {
           type: Boolean,
           default: false
       },
       diente: Object,
       idDenticion: {
           type: Number,
           required: true,
           default: null
       },
       idTagMotivoCita: {
           type: Number,
           required: true,
           default: null
       },
       idClinica: {
           type: Number,
           required: true,
           default: null
       },
       idPaciente: Number,
       idEmpleado: Number,
       index: null,
       segundaOpcionCreada: Boolean,
       segundaOpcionSeleccionada: Number,
       ordenar: Boolean,
       multiTrt: Boolean,
       modificar: Boolean,
       quitarSegundaOpcion: Boolean,
       ordenarOds: Boolean,
       obtenerSugerencias: {
           type: Boolean,
           default: false
       },
   },
   data: () => {
       return {
         version: process.env.VUE_APP_ENV_VERSION,
         debug: false,
           auxiliar: 0,
           opcionTabSeleccionada: 0,
           opciones: [
               {nombre: "Tratamientos"},
               {nombre: "Padecimientos"},
               {nombre: "Sugerencias"}
           ],
           padecimientos: [],
           padecimientosAdicionalesNoReq: [],
           catalogosServicios: new CatalogosService(),
           listaDientes: [],
           esconder: false,
           paquetes: {
               paquete1: [],
               paquete2: [],
               paquete3: [],
           },
           seccPadAd: 1,
           sugerenicaUno: [],
           sugerenicaDos: [],
           sugerenicaTres: [],
           loading: false,
           clasificacionClinicas: [],
           clasificacionClinicasLimitada: [],
       }
   },
   created() {
     this.debug = this.$localStorageService.getDebug();
       this.obtenerPadecimientos()
       this.obtenerClasificacionClinica()
   },
   mounted() {
       if (this.idPadecimiento != null) {
           //this.obtenerTratamientosDecentralizada();
           this.obtenerTratamientosDecentralizadaV2();
           if (this.diente.padecimientosAdicionalesNoReq != undefined && this.diente.padecimientosAdicionalesNoReq != null) {
           this.padecimientosAdicionalesNoReq = this.diente.padecimientosAdicionalesNoReq;
           }
       }
   },
   computed: {
    padecimientoExiste() {
      return this.diente.padecimiento && this.diente.padecimiento.idClasificacionClinica != null;
    },
       idPadecimiento() {
           if (this.diente.padecimiento === null) {
               return null
           }
           return this.diente.padecimiento.idPadecimiento;
       },
       segundaOpcionCreadaValidar(){
           if(this.segundaOpcionCreada === true){
               return true
           }else{
               return false
           }
       },
       hasEmpty() {
           console.info(this.padecimientosAdicionalesNoReq.filter(it=>it.pad==null));
           return this.padecimientosAdicionalesNoReq !== undefined
               && this.padecimientosAdicionalesNoReq !== null
               && this.padecimientosAdicionalesNoReq.filter(it=>it.pad==null).length>0;
       },
       hasDuplicates() {
           if (this.hasEmpty) {
               return false;
           }
           const valUnicos = this.padecimientosAdicionalesNoReq.filter(it=>it.pad!=null).map(it => it.pad);
               if (valUnicos.length == 0) {
               return false;
           }
           return (new Set(valUnicos)).size !== this.padecimientosAdicionalesNoReq.length;
       },
   },
   watch: {
       "diente.visible": function(){
       },
       auxiliar(newVal) {
           if(this.diente.padecimiento == null){
               let objetoBuscado = this.padecimientos.find(objeto => objeto.idPadecimiento == newVal);
               this.diente.padecimiento = objetoBuscado;
           }   
           
       },
       idPadecimiento() {
           this.obtenerTratamientosDecentralizadaV2();
       },
       segundaOpcionCreadaValidar(){
           this.obtenerTratamientosDecentralizadaV2();
       },
     "diente.padecimientoAux": function () {
       let objetoBuscado = this.padecimientos.find(objeto => objeto.idPadecimiento === this.diente.padecimientoAux);
       this.diente.padecimiento = objetoBuscado
     }
   },
   methods: {
       cambiarVisibilidad(){
           this.diente.visible = !this.diente.visible;
           this.$emit('cambiarVisibilidad')
       },
       cambiarPaquete(index, paquete) {
           this.diente.tratamientos = this.diente.tratamientos.map((l, i) => {
               if (i === index) {
                   l = paquete;
                   l.forEach(element => {
                       element.modificado = true;
                   });
               }
               return l
           })
           this.diente.padecimiento.modificado = true;
       },
       padecimientoModificado(){
        this.diente.padecimiento.modificado = true;
       },
       pestaniaTratamientos(numPestania){
           this.seccPadAd = numPestania
           if(this.diente.tratamientos.length == 0){
               this.diente.tratamientos.push([])
           }
       },

       obtenerTratamientosDecentralizadaV2(){
            if(this.modificar){
                this.diente.padecimiento.modificado = false;
            }
            if(this.diente.padecimiento.modificado !== undefined && this.diente.padecimiento.modificado === true){
                return
            }
            const params = {
                idClinica: this.idClinica,
                idPadecimiento: this.diente.padecimiento.idPadecimiento,
                idDiente: this.diente.diente.idDiente,
                denticion: this.idDenticion
            }
            this.loading = true;
            this.$http.post(this.$api + 'version5/ptipresuntivo/obtener/tratamientos/configurados',params).then(response=>{
                const datos = response.data.data
                if(!this.multiTrt && !this.ordenarOds){
                    if (this.diente.padecimiento != null && this.diente.buscar === true) {
                        this.sugerenicaUno =  datos.tratamientos1;
                        this.sugerenicaDos =  datos.tratamientos2;
                        this.sugerenicaTres =  datos.tratamientos3;
                        this.loading = false;
                        
                        let trt1 = []
                        if(this.diente.tratamientos.length == 0){
                            trt1.push(datos.tratamientos1.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos1)) : [])
                        }else{
                            trt1 = this.diente.tratamientos[0];
                        }

                        if(this.segundaOpcionCreada === false){
                            if(!this.quitarSegundaOpcion){
                                this.diente.tratamientos = [];
                                this.diente.tratamientos.push(datos.tratamientos1.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos1)) : [])
                            }else{
                                this.diente.tratamientos.splice(1,1)
                            }
                        }
                        
                        if(this.segundaOpcionCreada === true && this.segundaOpcionSeleccionada == 1){
                            this.diente.tratamientos = [];
                            this.diente.tratamientos.push(trt1.length > 0 ? trt1 : [])
                            this.diente.tratamientos.push(datos.tratamientos2.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos2)) : [])
                        }else if(this.segundaOpcionCreada === true && this.segundaOpcionSeleccionada === 2){
                            this.diente.tratamientos = [];
                            this.diente.tratamientos.push(trt1.length > 0 ? JSON.parse(JSON.stringify(trt1)) : [])
                            this.diente.tratamientos.push(trt1.length > 0 ? JSON.parse(JSON.stringify(trt1)) : [])
                        }else if(this.segundaOpcionCreada === true && this.segundaOpcionSeleccionada === 0){
                            this.diente.tratamientos = [];
                            this.diente.tratamientos.push(datos.tratamientos1.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos1)) : [])
                            this.diente.tratamientos.push(datos.tratamientos2.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos2)) : [])
                        }
                        
                        this.paquetes.paquete1 = JSON.parse(JSON.stringify(datos.tratamientos1));
                        this.paquetes.paquete2 = JSON.parse(JSON.stringify(datos.tratamientos2));
                        this.paquetes.paquete3 = JSON.parse(JSON.stringify(datos.tratamientos3));
                        this.sugerenicaUno =  JSON.parse(JSON.stringify(datos.tratamientos1));
                        this.sugerenicaDos =  JSON.parse(JSON.stringify(datos.tratamientos2));
                        this.sugerenicaTres =  JSON.parse(JSON.stringify(datos.tratamientos3));

                    } else {
                        this.loading = false;
                        if(this.segundaOpcionCreada === false && this.segundaOpcionSeleccionada == 0){
                            this.diente.tratamientos.splice(1, 1);
                        }else if(this.segundaOpcionCreada === true && this.segundaOpcionSeleccionada == 1){
                            this.diente.tratamientos.push(datos.tratamientos2.length > 0 ? JSON.parse(JSON.stringify(datos.tratamientos2)) : [])
                        }else if(this.segundaOpcionCreada === true && this.segundaOpcionSeleccionada === 2){
                            this.diente.tratamientos.push(this.diente.tratamientos[0].length > 0 ? JSON.parse(JSON.stringify(this.diente.tratamientos[0])) : [])
                        }
                        this.paquetes.paquete1 = this.diente.tratamientos[0]
                        this.paquetes.paquete2 = this.diente.tratamientos[1]
                        this.paquetes.paquete3 = this.diente.tratamientos[2]
                        this.sugerenicaUno =  JSON.parse(JSON.stringify(datos.tratamientos1));
                        this.sugerenicaDos =  JSON.parse(JSON.stringify(datos.tratamientos2));
                        this.sugerenicaTres =  JSON.parse(JSON.stringify(datos.tratamientos3));
                    }
                }else{
                    this.loading = false;
                    this.sugerenicaUno =  datos.tratamientos1;
                    this.sugerenicaDos =  datos.tratamientos2;
                    this.sugerenicaTres =  datos.tratamientos3;
                }
            })
       },
       
       obtenerPadecimientos() {
           const params = {
               denticion: this.idDenticion,
               idTagMotivoCita: this.idTagMotivoCita
           }
           this.catalogosServicios.obetenerPadecimientosPorDienteDescentralizados(params).then(
               response => {
                   this.padecimientos = [
                       { idPadecimiento: null, descripcion: "Selecciona un padecimiento" },
                       ...response.data
                   ];
               }
           ).finally(() => {
             let padecimientos = JSON.parse(JSON.stringify(this.padecimientos));
             this.$emit('padOrtodonciaModificado', padecimientos.filter(p=>p.idPadecimiento === 216));
           })
       },

       obtenerClasificacionClinica() {
           this.clasificacionClinicas = [];
           this.$http.get(this.$api + "catalogos/obtenerClasificacionClinica").then((response) => {
               this.clasificacionClinicas = response.data.data;
               this.clasificacionClinicasLimitada = JSON.parse(JSON.stringify(response.data.data))
               this.clasificacionClinicasLimitada = this.clasificacionClinicasLimitada.filter(cl=>cl.idClasificacionClinica == 1);
               this.$emit('clasificacionesClinicas', this.clasificacionClinicas);
           });
       },

       eliminarDiente() {
           this.$emit('eliminarDiente', this.diente)
       },
 
       agregarPadecimientoAdicional() {
           if (this.padecimientosAdicionalesNoReq === undefined || this.padecimientosAdicionalesNoReq === null) {
               this.padecimientosAdicionalesNoReq = [{
                   "pad": null
               }];
           } else {
               this.padecimientosAdicionalesNoReq.push({
                   "pad": null
               });
           }
           this.actualizarPadecimientosAdds();
       },
   
       submitf(e) {
           e.prevent.default();
       },
   
       quitarPadecimientoAdicional(idx) {
           this.padecimientosAdicionalesNoReq.splice(idx, 1);
           this.actualizarPadecimientosAdds();
       },
   
       actualizarPadecimientosAdds() {
           this.$refs.ads.checkValidity();
           this.$emit('actualizarPadsAddNoReq', {
               idDiente: this.diente.diente.idDiente,
               pads: JSON.parse(JSON.stringify(this.padecimientosAdicionalesNoReq))
           });
       },
   
       cambioPadecimiento(){
           //padecimiento.cambio = true;
           this.ordenar = false;
           this.diente.padecimiento.modificado = false;
           this.$emit('cambioPadecimiento');
       }
   }
 }
 </script>
 
 <style scoped>
 .tabTxtSeleccionado {
   font-size: 0.9vw;
   color: #17a2b8;
   width: 100%;
   }

   .tabTxt {
   font-size: 0.9vw;
   color: #717171;
   }

   .tabOpciones.seleccionado {
   border-style: solid;
   border-width: 1px;
   border-color: #90d3dd;
   border-radius: 10px;
   color: #17a2b8;
   }

   .tabOpciones:hover {
   font-weight: 600;
   }
   .tituloSugerencia{
       font-weight: bold;
       font-style: italic;
       color: #3C3C3C !important;
   }

   .select{
   border: none !important;
   border-bottom: 2px solid #90D3DD !important;
   box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
 }

 .select:focus{
   border: none !important;
   box-shadow: 0px 1px 4px 0px #90D3DD;
 }

 .esconder[aria-expanded="true"] {
   display: none;
 }
 
 .esconder[aria-expanded="false"] {
   display: initial;
 }
 
 .mostrar[aria-expanded="true"] {
   display: initial;
 }
 
 .mostrar[aria-expanded="false"] {
   display: none;
 }
 
 .descripcionDiente {
   margin-right: 1rem;
   border-right: solid 1px #c7c7c7
 }
 
 </style>
